// @flow
import * as React from 'react'
import { Helmet } from 'react-helmet'

type MetaProps = {|
  title?: string,
  description?: string,
  keywords?: ?Array<string>,
|}

const Meta = (props: MetaProps) => {
  const { title, description, keywords } = props
  const div = document.createElement('div')
  div.innerHTML = description || ''
  const strippedDescription = div.textContent || div.innerText || ''
  return (
    <Helmet>
      {title && <title>{`All Inclusive Vacations - ${title}`}</title>}
      {description && <meta name="description" content={strippedDescription} />}
      {keywords && keywords.length > 0 && <meta name="keywords" content={keywords.join(', ')} />}
    </Helmet>
  )
}

Meta.defaultProps = {
  title: null,
  description: '',
  keywords: [],
}

export default Meta
